import { TaskType } from '@droidmap/project-service-contract'

export const TASK_TYPE_LABEL: Record<TaskType, string> = {
  [TaskType.Photogrammetry]: 'Photogrammetry',
  [TaskType.GCPTagging]: 'GCP Tagging',
}
